(function () {
  'use strict';

  var COUNTRIES = [
    {
      code: 'SE', flag: '🇸🇪', name: 'Schweden',
      status: 'allowed', statusLabel: 'Weitgehend erlaubt',
      summary: 'Schweden hat dank des Jedermannsrechts (Allemansrätten) eine der großzügigsten Wildcamping-Regelungen Europas. Du darfst bis zu zwei Nächte auf fremdem Grund zelten – auch mit Dachzelt – solange du Privateigentum respektierst und keine Schäden hinterlässt.',
      rules: [
        'Bis zu 2 Nächte auf fast jedem Grund erlaubt (Allemansrätten)',
        'Mindestens 70 m Abstand zu Wohnhäusern einhalten',
        'Kein Feuer bei Trockenheit oder Feuerverbot',
        'Keinen Abfall hinterlassen, Natur nicht beschädigen',
        'Nationalparks und Naturschutzgebiete: gesonderte Regeln beachten'
      ],
      fines: 'Keine Standardstrafe – Schäden können zivilrechtlich geltend gemacht werden',
      tips: [
        'Fahre abseits der touristischen Hotspots – Schweden ist riesig',
        'App Naturkartan zeigt Schutzgebiete und empfohlene Spots',
        'Dachzelt auf Parkplätzen gilt ebenfalls als gecampter Spot'
      ],
      apps: ['Naturkartan', 'park4night', 'iOverlander']
    },
    {
      code: 'NO', flag: '🇳🇴', name: 'Norwegen',
      status: 'allowed', statusLabel: 'Weitgehend erlaubt',
      summary: 'In Norwegen gilt das Friluftsloven (Jedermannsrecht) seit 1957 gesetzlich. Wildcamping ist in der freien Natur erlaubt, mindestens 150 m von Wohnhäusern entfernt. Mit Dachzelt kannst du die beeindruckenden Fjordlandschaften frei erkunden.',
      rules: [
        'Mindestens 150 m Abstand zu bewohnten Häusern und Hütten',
        'Maximal 2 Nächte an derselben Stelle ohne Erlaubnis',
        'In Nationalparks gelten Sonderregeln – oft nur ausgewiesene Plätze',
        'Keine Schäden an Vegetation, kein Müll zurücklassen',
        'Feuer von 15. April bis 15. September verboten in der Natur'
      ],
      fines: 'Verstöße: Bußgelder variieren je nach Gemeinde, selten durchgesetzt',
      tips: [
        'UT.no zeigt offizielle Wanderwege und empfohlene Übernachtungsplätze',
        'Dachzelte sind in Norwegen sehr akzeptiert – Overlanding-Community ist groß',
        'Im Sommer: Mitternachtssonne nutzen, aber Schlafmaske mitnehmen'
      ],
      apps: ['UT.no', 'park4night', 'Maps.me']
    },
    {
      code: 'FI', flag: '🇫🇮', name: 'Finnland',
      status: 'allowed', statusLabel: 'Weitgehend erlaubt',
      summary: 'Finnlands Jedermannsrecht (Jokamiehenoikeus) erlaubt Wildcamping in der freien Natur. Das Land mit über 188.000 Seen bietet unzählige legale Möglichkeiten für Dachzelt-Camper.',
      rules: [
        'Jedermannsrecht erlaubt kurzzeitiges Zelten in der freien Natur',
        'Mindestens 100 m Abstand zu Wohngebäuden',
        'Nicht länger als eine Nacht ohne Erlaubnis an derselben Stelle',
        'Nationalparks: nur ausgewiesene Campingplätze nutzen',
        'Feuermachen nur an erlaubten Stellen oder mit Erlaubnis des Grundeigentümers'
      ],
      fines: 'Verstöße gegen Parkregeln: 40–200 €',
      tips: [
        'Retkikartta.fi zeigt alle Nationalparks und Campingzonen',
        'Insektenschutz nicht vergessen – Mücken im Sommer stark',
        'Viele Seeufer und Waldwege sind ideal für Dachzelt-Nächte'
      ],
      apps: ['Retkikartta.fi', 'park4night', 'iOverlander']
    },
    {
      code: 'IS', flag: '🇮🇸', name: 'Island',
      status: 'restricted', statusLabel: 'Eingeschränkt (Regeln beachten)',
      summary: 'Island hat sein Wildcamping-Recht nach Übertourismus deutlich eingeschränkt. Seit 2015 ist Wildcamping auf privatem Grund und in sensiblen Gebieten verboten. Ausgewiesene Campingplätze müssen genutzt werden.',
      rules: [
        'Wildcamping auf privatem Land ist verboten ohne Erlaubnis',
        'In Schutzgebieten (z. B. Þingvellir) ausschließlich Campingplätze',
        'Außerhalb von Schutzgebieten auf unbebauten Flächen möglich',
        'Fahrzeuge dürfen nicht abseits der Straßen fahren (empfindliches Gelände)',
        'Feuermachen ist streng verboten (Feuergefahr, Moose)'
      ],
      fines: 'Unbefugtes Befahren von Vegetation: bis zu 500.000 ISK (~3.300 €)',
      tips: [
        'Campingplätze sind sehr günstig (~€10–15 pro Nacht) und oft malerisch gelegen',
        'Campa App zeigt alle offiziellen Campingplätze Islands',
        'Dachzelt nur auf Campingplätzen oder mit ausdrücklicher Grundeigentümer-Erlaubnis'
      ],
      apps: ['Campa Iceland', 'park4night', 'Appy Hour Iceland']
    },
    {
      code: 'GB', flag: '🇬🇧', name: 'Schottland',
      status: 'allowed', statusLabel: 'Legal (nur Schottland)',
      summary: 'Schottland hat als einziger Teil Großbritanniens ein gesetzliches Recht auf Wildcamping (Land Reform Act 2003). England und Wales haben dieses Recht NICHT – dort ist Wildcamping auf privatem Grund verboten.',
      rules: [
        'Schottland: Recht auf verantwortungsvolles Wildcamping auf den meisten Flächen',
        'Loch Lomond: Camping-Management-Zone – bestimmte Ufer nur mit Permit',
        'England/Wales: Wildcamping auf privatem Grund illegal ohne Erlaubnis',
        'Keine Schäden, kein Müll, kein Feuer auf trockenem Heidekraut',
        'Nutztiere nicht stören, Zäune nicht überklettern'
      ],
      fines: 'England/Wales: Hausfriedensbruch, Bußgelder variieren',
      tips: [
        'Schottland ist ein Paradies für Dachzelt-Overlander – wenig Traffic, viele Wege',
        'Loch Ness, Cairngorms, Northwest Highlands: atemberaubende Spots',
        'WildCamping Scotland App für geprüfte Spots und aktuelle Regeln'
      ],
      apps: ['park4night', 'iOverlander', 'OS Maps']
    },
    {
      code: 'DK', flag: '🇩🇰', name: 'Dänemark',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'In Dänemark ist Wildcamping auf privatem Grund generell verboten. Erlaubt ist es nur in ausgewiesenen "Primitive Camping"-Plätzen (ca. 1.000 Spots) und in bestimmten Staatswäldern. Dachzelte auf Parkplätzen gelten als Camping.',
      rules: [
        'Wildcamping nur auf offiziell ausgewiesenen primitiven Campingplätzen',
        'Staatswälder: einige erlauben Übernachtung auf markierten Flächen',
        'Strände und Dünen: verboten (Naturschutz)',
        'Dachzelt ausgeklappt auf öffentlichem Parkplatz: gilt als Camping',
        'Genehmigung des Grundeigentümers erforderlich für privates Land'
      ],
      fines: '500–3.000 DKK (~65–400 €)',
      tips: [
        'Naturligo.dk zeigt alle legalen primitiven Camping-Spots',
        'Für Dachzelt-Reisen: Campingplätze in DK sehr günstig und zahlreich',
        'Einige Naturgebiete erlauben 1 Nacht mit Genehmigung'
      ],
      apps: ['Naturligo.dk', 'park4night', 'CampOne']
    },
    {
      code: 'NL', flag: '🇳🇱', name: 'Niederlande',
      status: 'forbidden', statusLabel: 'Verboten',
      summary: 'In den Niederlanden ist Wildcamping grundsätzlich verboten. Das dicht besiedelte Land hat kaum freie Flächen, und Übernachten außerhalb ausgewiesener Campingplätze ist strafbar.',
      rules: [
        'Wildcamping landesweit verboten',
        'Ausnahme: einige Naturschutzgebiete mit speziellem Permit',
        'Dachzelt auf Parkplatz ausgeklappt: Bußgeld möglich',
        'Nationalparks: strikte Kontrollen, keine Ausnahmen',
        'Campingplätze sind sehr zahlreich und erschwinglich'
      ],
      fines: '90–450 €',
      tips: [
        'Minicampings (private Bauernhöfe mit Stellplätzen) sind eine günstige Alternative',
        'ANWB-App zeigt alle offiziellen Campingplätze',
        'Spontane Übernachtung: Camping.info für Lastminute-Verfügbarkeit nutzen'
      ],
      apps: ['ANWB Camping', 'park4night', 'Camping.info']
    },
    {
      code: 'BE', flag: '🇧🇪', name: 'Belgien',
      status: 'forbidden', statusLabel: 'Verboten',
      summary: 'In Belgien ist Wildcamping generell verboten. Das Camping- und Tourismusgesetz der Wallonie und Flandern verbietet Übernachten außerhalb zugelassener Plätze ausdrücklich. Waldgebiete und Naturschutzgebiete werden aktiv kontrolliert.',
      rules: [
        'Wildcamping landesweit verboten (Flandern, Wallonie, Brüssel)',
        'Ardennen und Haute Fagnes: Naturschutzgebiet, strikte Kontrollen',
        'Dachzelt auf Parkplatz ausgeklappt: gilt als Camping, Bußgeld möglich',
        'Privates Land: nur mit ausdrücklicher Genehmigung',
        'Küstenregion: absolutes Verbot, aktive Polizeipräsenz'
      ],
      fines: '50–500 € (regional variierend)',
      tips: [
        'Belgien hat sehr günstige Campingplätze, besonders in den Ardennen',
        'park4night zeigt legale Stellplätze und Campingplätze',
        'Glamping-Angebote in Baumhäusern und Safarizelten als Alternative'
      ],
      apps: ['park4night', 'Camping.info', 'iOverlander']
    },
    {
      code: 'DE', flag: '🇩🇪', name: 'Deutschland',
      status: 'restricted', statusLabel: 'Verboten – mit Grauzone',
      summary: 'Wildcamping ist in Deutschland grundsätzlich verboten. Es gibt jedoch eine bekannte rechtliche Grauzone: § 12 StVO erlaubt das Übernachten auf öffentlichen Parkplätzen für eine Nacht zur Erholung. Ob das Dachzelt dabei ausgeklappt werden darf, hängt entscheidend vom Zelttyp ab.',
      rules: [
        'Wildcamping verboten: Bundeswaldgesetz § 14 + Landesnaturschutzgesetze',
        'Auf Privatgrund ohne Erlaubnis: Hausfriedensbruch',
        '⚡ Grauzone § 12 StVO: 1 Nacht auf öffentl. Parkplatz zur Erholung erlaubt',
        'Hartschalenzelt öffnet nach oben – bleibt im Fahrzeugumriss → geringeres Risiko',
        'Klappdachzelt ragt über Fahrzeugbreite → wirkt als Camping-Signal, höheres Risiko',
        'Keine Markise, Stühle, Tisch oder Grill – sonst kippt Rast in Wildcamping',
        'Bayern, BW, NRW: besonders strenge Auslegung'
      ],
      fines: '50–500 €, in Schutzgebieten bis 50.000 €',
      tips: [
        'Schlüssel raus aus dem Zündschloss – am besten ins Zelt legen',
        'Sag: "Ich stelle meine Fahrtüchtigkeit wieder her" – nie "Ich cample hier"',
        'Hartschalenzelt (Taiga, Skylodge) hat bessere Argumente als Klappdachzelt',
        'stellplatz.info und park4night zeigen tausende legale Spots',
        'Max. 1 Nacht pro Ort – dann weiterfahren'
      ],
      apps: ['stellplatz.info', 'park4night', 'Camping.info']
    },
    {
      code: 'AT', flag: '🇦🇹', name: 'Österreich',
      status: 'forbidden', statusLabel: 'Verboten',
      summary: 'In Österreich ist Wildcamping auf privaten und öffentlichen Flächen generell verboten. Die Regelungen variieren leicht je nach Bundesland, aber die Grundregel bleibt: nur auf ausgewiesenen Campingplätzen.',
      rules: [
        'Wildcamping verboten – landesrechtliche Regelungen je nach Bundesland',
        'Alpinvereinshütten bieten Notbiwak-Regelungen für echte Bergnotfälle',
        'Tirol, Salzburg: aktive Kontrollen im Sommer',
        'Nationalparks (Hohe Tauern etc.): absolutes Campingverbot',
        'Auf Parkplätzen mit aufgeklapptem Dachzelt: Bußgeld möglich'
      ],
      fines: '70–3.000 €',
      tips: [
        'Alpencamping Österreich App für legale Plätze',
        'Viele Bergcampingplätze in Österreich sind preiswert und spektakulär gelegen',
        'Einige Gemeinden dulden Übernachtung auf markierten Almwegen'
      ],
      apps: ['park4night', 'Camping.info', 'iOverlander']
    },
    {
      code: 'CH', flag: '🇨🇭', name: 'Schweiz',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'In der Schweiz ist Wildcamping in der Landschaft außerhalb des Waldes grundsätzlich erlaubt – im Wald hingegen verboten. Oberhalb der Waldgrenze (ab ca. 1.500 m) ist Biwakieren legal, darunter gelten strengere Regeln.',
      rules: [
        'Oberhalb der Waldgrenze: Wildcamping / Biwakieren erlaubt',
        'Im Wald und auf Kulturflächen: verboten',
        'Schutzgebiete und Nationalparks: absolutes Verbot',
        'Kanton Zürich, Genf: besonders strenge Auslegung',
        'Lärm und Feuer sind zu vermeiden – Buße bei Verstößen'
      ],
      fines: '100–1.000 CHF (~105–1.050 €)',
      tips: [
        'Swisstopo-App zeigt Schutzgebiete und Waldgrenzen',
        'Für Dachzelt-Overlander: Campingplätze in der Schweiz sind hochwertig',
        'TCS (Touring Club Schweiz) Campingführer für alle Plätze'
      ],
      apps: ['Swisstopo', 'park4night', 'TCS Camping']
    },
    {
      code: 'PL', flag: '🇵🇱', name: 'Polen',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'In Polen ist Wildcamping in Staatswäldern und Nationalparks verboten. Auf privatem Grund mit Erlaubnis ist es möglich. Die Durchsetzung ist im Vergleich zu Westeuropa lockerer, aber Nationalparks werden kontrolliert.',
      rules: [
        'Staatswälder: verboten ohne Sondergenehmigung',
        'Nationalparks: strenges Verbot',
        'Privates Land mit Erlaubnis: legal',
        'Manche ländlichen Regionen werden kaum kontrolliert',
        'Offene Feuer im Wald verboten'
      ],
      fines: '500–5.000 PLN (~115–1.150 €)',
      tips: [
        'Mapa Turystyczna.pl zeigt Campingplätze und Schutzgebiete',
        'Viele polnische Bauern erlauben Übernachtung gegen kleine Gebühr',
        'Ostseeküste und Masuren: viele unkomplizierte Strandplätze'
      ],
      apps: ['park4night', 'iOverlander', 'Mapa Turystyczna']
    },
    {
      code: 'CZ', flag: '🇨🇿', name: 'Tschechien',
      status: 'forbidden', statusLabel: 'Verboten',
      summary: 'In Tschechien ist Wildcamping grundsätzlich verboten. Die Regeln ähneln Deutschland: Übernachten außerhalb ausgewiesener Campingplätze ist nicht erlaubt, wird aber in abgelegenen Gebieten selten kontrolliert.',
      rules: [
        'Wildcamping landesweit verboten',
        'Nationalparks (Böhmische Schweiz, Šumava): strikte Kontrollen',
        'Auf Privatgrund mit Erlaubnis: toleriert',
        'Böhmerwald-Region: aktivere Kontrollen im Sommer',
        'Dachzelt auf Parkplatz ausgeklappt: Risiko einer Strafe'
      ],
      fines: '1.000–10.000 CZK (~40–400 €)',
      tips: [
        'KempinKy.cz zeigt günstige Campingplätze in ganz Tschechien',
        'Viele Bauernhöfe bieten inoffizielle Stellplätze an',
        'park4night hat viele geprüfte Spots in Tschechien'
      ],
      apps: ['park4night', 'KempinKy.cz', 'iOverlander']
    },
    {
      code: 'SK', flag: '🇸🇰', name: 'Slowakei',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'In der Slowakei ist Wildcamping offiziell verboten, wird aber in abgelegenen Berg- und Waldregionen oft toleriert. Die Hohe Tatra und andere Nationalparks sind streng reguliert. In ländlichen Gebieten abseits touristischer Routen ist die Kontrolldichte gering.',
      rules: [
        'Wildcamping außerhalb ausgewiesener Plätze verboten',
        'Nationalparks (Hohe Tatra, Niedere Tatra): absolutes Verbot',
        'Ländliche Regionen: oft toleriert, selten kontrolliert',
        'Privates Land: nur mit Erlaubnis',
        'Feuer im Wald grundsätzlich verboten'
      ],
      fines: '50–500 € (regional variierend)',
      tips: [
        'Kempinguj.sk zeigt offizielle Campingplätze in der Slowakei',
        'Viele Bauernhöfe bieten günstige Stellplätze an',
        'Slowakisches Paradies und Mala Fatra: wunderschöne Regionen mit Campingplätzen'
      ],
      apps: ['park4night', 'iOverlander', 'Kempinguj.sk']
    },
    {
      code: 'HU', flag: '🇭🇺', name: 'Ungarn',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'In Ungarn ist Wildcamping außerhalb zugelassener Campingplätze verboten. In der Praxis wird es in ländlichen Gebieten und an Seen (außerhalb der Hauptsaison) manchmal toleriert. Nationalparks und Schutzgebiete werden kontrolliert.',
      rules: [
        'Wildcamping außerhalb ausgewiesener Plätze verboten',
        'Nationalparks (Hortobágy, Bakony): strikte Regeln',
        'Privatgelände: nur mit ausdrücklicher Erlaubnis',
        'Balaton-Region: aktive Kontrollen in der Sommersaison',
        'Feuer in der freien Natur generell verboten'
      ],
      fines: '50.000–200.000 HUF (~130–520 €)',
      tips: [
        'Ungarn hat sehr günstige Campingplätze am Balaton und in der Tiefebene',
        'park4night zeigt geprüfte Spots und legale Stellplätze',
        'Ländliche Gegenden der Puszta sind für Overlander besonders reizvoll'
      ],
      apps: ['park4night', 'iOverlander', 'Camping.info']
    },
    {
      code: 'RO', flag: '🇷🇴', name: 'Rumänien',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'Rumänien ist eines der tolerantesten Länder Europas für Wildcamper. In den Karpaten und in Transsylvanien wird es weitgehend geduldet. Nationalparks haben strengere Regeln. Die Kontrolldichte ist im Vergleich zu Westeuropa gering.',
      rules: [
        'Kein explizites nationales Verbot in der freien Natur – Grauzone',
        'Nationalparks (Retezat, Bucegi): offizielle Plätze nutzen',
        'Donaudelta: Schutzgebiet, keine Ausnahmen',
        'Privatgelände: immer Erlaubnis erfragen',
        'Feuer nur auf ausgewiesenen Feuerstellen'
      ],
      fines: 'Variiert je nach Region und Schutzgebiet: 200–1.000 RON (~40–200 €)',
      tips: [
        'Karpaten und Transsylvanien: sehr tolerant, spektakuläre Landschaft',
        'iOverlander hat viele Dachzelt-erprobte Spots in Rumänien',
        'Lokale Bauern bieten oft kostenlose Übernachtung auf dem Hof an'
      ],
      apps: ['iOverlander', 'park4night', 'Maps.me']
    },
    {
      code: 'FR', flag: '🇫🇷', name: 'Frankreich',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'In Frankreich ist Wildcamping zwar offiziell verboten, wird aber in ländlichen Gebieten und fernab von Wohngebieten oft toleriert. Streng verboten ist es in Nationalparks, an Küsten und innerhalb von Ortschaften.',
      rules: [
        'Offiziell verboten, in der Praxis in Bergregionen oft toleriert',
        'Nationalparks: absolutes Verbot (Mercantour, Écrins etc.)',
        'Küstengebiete: strikt verboten (loi littorale)',
        'Mindestens 500 m von Campingplätzen entfernt',
        'Feuer im Freien verboten (ganzjährig in Südfrankreich im Sommer)'
      ],
      fines: '750–1.500 € (bei Nationalparks höher)',
      tips: [
        'France Passion ermöglicht Übernachtungen bei Winzern und Bauern',
        'Aires de Camping-Car: kostenlose oder günstige Stellplätze für Fahrzeuge',
        'Gorges du Verdon, Alpen, Pyrenäen: Hochlagen mit weniger Kontrollen'
      ],
      apps: ['France Passion', 'park4night', 'Camping-Car Park']
    },
    {
      code: 'SI', flag: '🇸🇮', name: 'Slowenien',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'In Slowenien ist Wildcamping verboten, wird aber in abgelegenen Bergregionen oft toleriert. Triglav-Nationalpark hat strikte Regeln. Das Land ist für Overlander wegen der Natur und günstiger Campingplätze beliebt.',
      rules: [
        'Wildcamping verboten, Durchsetzung variiert regional',
        'Triglav Nationalpark: absolutes Campingverbot außerhalb markierter Plätze',
        'Julische Alpen: höhere Toleranz für Biwakieren in großer Höhe',
        'Privates Land: nur mit ausdrücklicher Erlaubnis',
        'Feuer im Freien verboten'
      ],
      fines: '200–1.000 €',
      tips: [
        'Kamping.si zeigt alle offiziellen Campingplätze',
        'Soča-Tal und Bohinj-See: traumhafte Campingregionen mit legalen Plätzen',
        'Viele Agro-Tourismus-Betriebe bieten Stellplätze an'
      ],
      apps: ['park4night', 'iOverlander', 'Kamping.si']
    },
    {
      code: 'HR', flag: '🇭🇷', name: 'Kroatien',
      status: 'forbidden', statusLabel: 'Streng verboten',
      warning: true,
      warningText: '⚠️ Achtung: Kroatien ist einer der strengsten EU-Staaten beim Wildcamping. Die Polizei kontrolliert aktiv, besonders an der Küste und in Nationalparks. Ein ausgeklapptes Dachzelt auf einem öffentlichen Parkplatz gilt als Wildcamping und wird mit 200–700 € bestraft.',
      summary: 'Wildcamping ist in Kroatien streng verboten und wird aktiv kontrolliert. Das Gesetz gilt ausdrücklich auch für Dachzelte auf Parkplätzen. Die Strafen werden regelmäßig verhängt – auch gegenüber Touristen.',
      rules: [
        'Wildcamping landesweit gesetzlich verboten (Turistička inspekcija)',
        'Dachzelt ausgeklappt auf Parkplatz gilt als illegales Camping',
        'Nationalparks (Plitvicer Seen, Krka): strenge Kontrollen, hohe Strafen',
        'Küstenregion (Dalmatien): Polizei patrouilliert aktiv in der Saison',
        'Auf privatem Grund: nur mit schriftlicher Genehmigung, Meldepflicht'
      ],
      fines: '200–700 € (Touristen werden nicht verschont)',
      tips: [
        'Camping.hr zeigt alle offiziellen Campingplätze – davon gibt es sehr viele',
        'Campingplätze in Kroatien sind oft direkt am Meer und erschwinglich',
        'Früh buchen in der Hochsaison (Juli/August)'
      ],
      apps: ['Camping.hr', 'park4night (nur für legale Spots)', 'iOverlander']
    },
    {
      code: 'IT', flag: '🇮🇹', name: 'Italien',
      status: 'forbidden', statusLabel: 'Verboten',
      summary: 'In Italien ist Wildcamping grundsätzlich verboten und wird von der Gemeindepolizei (Vigili) sowie Carabinieri geahndet. In abgelegenen Bergregionen wird es manchmal toleriert, ist aber rechtlich nicht abgesichert.',
      rules: [
        "Wildcamping landesweit verboten (Testo Unico sull'Ambiente)",
        'Strandzonen: absolutes Verbot, besonders in der Saison',
        'Nationalparks: strikte Kontrollen, Bußgelder',
        'Bergregionen (Dolomiten, Apennin): höhere Toleranz über 2.000 m',
        'Auf Privatgrund: nur mit Erlaubnis'
      ],
      fines: '100–500 € (Strände: bis 1.000 €)',
      tips: [
        'Agricampeggio.it für Stellplätze bei Bauernhöfen',
        'Viele Agriturismo-Betriebe bieten günstige Übernachtungen an',
        'Südtirol und Trentino: etwas toleranter als Küstenregionen'
      ],
      apps: ['park4night', 'iOverlander', 'Agricampeggio']
    },
    {
      code: 'ES', flag: '🇪🇸', name: 'Spanien',
      status: 'forbidden', statusLabel: 'Verboten',
      summary: 'In Spanien ist Wildcamping verboten und wird regional unterschiedlich durchgesetzt. Küstenregionen sind besonders streng. In Kastilien und Extremadura (Meseta) wird es manchmal toleriert. Kanaren haben eigene Regeln.',
      rules: [
        'Bundes- und Regionalgesetze verbieten Wildcamping generell',
        'Küsten (Ley de Costas): absolutes Verbot innerhalb 500 m',
        'Nationalparks: strikte Kontrollen',
        'Kastilien-La Mancha, Extremadura: mehr Toleranz in leeren Regionen',
        'Fahrzeug-Camping auf Parkplätzen: Bußgeld möglich'
      ],
      fines: '300–3.000 € (regional)',
      tips: [
        'Spanien hat sehr günstige Campingplätze (ab €8 pro Nacht)',
        'Camper Stop App zeigt Stellplätze auf Weingütern etc.',
        'Picos de Europa, Pyrenäen: Hochlagen mit weniger Kontrollen'
      ],
      apps: ['park4night', 'Camper Stop', 'iOverlander']
    },
    {
      code: 'PT', flag: '🇵🇹', name: 'Portugal',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'Portugal ist toleranter als Spanien, aber auch hier ist Wildcamping offiziell verboten. In der Praxis wird es in ländlichen Regionen des Alentejo und im Norden selten kontrolliert. Nationalparks und Küsten sind ausgenommen.',
      rules: [
        'Offizielle Gesetzeslage: verboten (Decreto-Lei 48/96)',
        'In der Praxis: in abgelegenen Gebieten oft toleriert',
        'Nationalparks (Peneda-Gerês etc.): Verbot wird durchgesetzt',
        'Küstengebiete: verboten (ähnlich wie Spanien)',
        'Alentejo und Trás-os-Montes: wenig Kontrollen'
      ],
      fines: '150–3.740 €',
      tips: [
        'Portugal hat viele kostenlose oder günstige Stellplätze (Áreas de Serviço)',
        'park4night hat hunderte verifizierter Spots in Portugal',
        'Alentejo ist ideal für entspanntes Dachzelt-Camping'
      ],
      apps: ['park4night', 'iOverlander', 'Camping Key Europe']
    },
    {
      code: 'BG', flag: '🇧🇬', name: 'Bulgarien',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'Bulgarien gehört zu den toleranteren Ländern auf dem Balkan. In den Rhodopen, im Rila- und Pirin-Gebirge wird Wildcamping oft geduldet. Nationalparks und Schwarzmeerküste sind strenger geregelt. Die Kontrolldichte ist insgesamt gering.',
      rules: [
        'Kein einheitliches nationales Verbot in freier Natur – Grauzone',
        'Nationalparks (Rila, Pirin): ausgewiesene Plätze nutzen',
        'Schwarzmeerküste: Verbot in Schutzgebieten, sonst Grauzone',
        'Privatgelände: Erlaubnis erforderlich',
        'Feuer nur an gekennzeichneten Feuerstellen erlaubt'
      ],
      fines: '100–500 BGN (~50–250 €)',
      tips: [
        'Rhodopen und Rila-Gebirge: beeindruckende Natur, wenig Kontrollen',
        'iOverlander hat viele verifizierte Spots für Bulgarien',
        'Freundliche Bevölkerung – auf Bauernhöfen fragen lohnt sich immer'
      ],
      apps: ['iOverlander', 'park4night', 'Maps.me']
    },
    {
      code: 'GR', flag: '🇬🇷', name: 'Griechenland',
      status: 'forbidden', statusLabel: 'Verboten',
      summary: 'In Griechenland ist Wildcamping verboten. Das Gesetz wird an Stränden und in der Nähe von Wohngebieten aktiv durchgesetzt. In abgelegenen Bergregionen ist die Kontrolldichte niedriger.',
      rules: [
        'Wildcamping landesweit verboten (Gesetz 1337/83)',
        'Strandzonen: aktive Kontrollen, Bußgelder',
        'Nationalparks: strikte Regeln',
        'Auf Olivenhainen oder Privatland: Strafverfolgung möglich',
        'Fahrzeug mit ausgeklapptem Dachzelt: gilt als Wildcamping'
      ],
      fines: '150–600 €',
      tips: [
        'Viele griechische Campingplätze sind preiswert und in Strandnähe',
        'Peleion, Epirus, Mazedonien: ländliche Gebiete mit mehr Toleranz',
        'park4night zeigt geprüfte Spots, die von anderen Campern gemeldet wurden'
      ],
      apps: ['park4night', 'iOverlander', 'Camping Greece']
    },
    {
      code: 'TR', flag: '🇹🇷', name: 'Türkei',
      status: 'restricted', statusLabel: 'Eingeschränkt',
      summary: 'In der Türkei existiert kein generelles Wildcampingverbot – es gibt aber auch kein gesetzliches Recht dazu. In der Praxis ist Wildcamping in ländlichen und bergigen Regionen weitgehend geduldet. Touristisch überlaufene Küstenorte sind ausgenommen.',
      rules: [
        'Kein explizites Verbot in der freien Natur – Grauzone',
        'Militärische Sperrgebiete und Nationalparks: absolutes Verbot',
        'Ägäis- und Mittelmeerstrand-Zonen: Kontrollen in der Hauptsaison',
        'Anatolien, Kappadokien, Schwarzmeerküste: sehr tolerant',
        'Privates Land: immer Erlaubnis erfragen (Tradition der Gastfreundschaft)'
      ],
      fines: 'Variiert – offiziell selten verhängt außerhalb von Schutzgebieten',
      tips: [
        'iOverlander hat viele Dachzelt-erprobte Spots in der Türkei',
        'Türkische Bevölkerung ist gegenüber Overlanding sehr aufgeschlossen',
        'Osten der Türkei (Van Gölü, Ararat-Region): spektakuläre freie Plätze'
      ],
      apps: ['iOverlander', 'park4night', 'Maps.me']
    }
  ];

  var STATUS_ORDER = { allowed: 0, restricted: 1, forbidden: 2 };

  function buildGrid() {
    var grid = document.getElementById('wcc-grid');
    if (!grid) return;
    COUNTRIES.forEach(function (c) {
      var btn = document.createElement('button');
      btn.className = 'wcc-country-btn wcc-status-' + c.status;
      btn.setAttribute('data-code', c.code);
      btn.setAttribute('data-name', c.name.toLowerCase());
      btn.setAttribute('aria-label', c.name);
      btn.innerHTML = '<span class="wcc-flag">' + c.flag + '</span><span class="wcc-cname">' + c.name.trim() + '</span>';
      btn.addEventListener('click', function () {
        document.querySelectorAll('.wcc-country-btn').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        showResult(c);
        var url = new URL(window.location.href);
        url.searchParams.set('land', c.code);
        history.replaceState(null, '', url.toString());
      });
      grid.appendChild(btn);
    });
  }

  function initSearch() {
    var input = document.getElementById('wcc-search');
    if (!input) return;
    input.addEventListener('input', function () {
      var q = input.value.toLowerCase().trim();
      document.querySelectorAll('.wcc-country-btn').forEach(function (btn) {
        var name = btn.getAttribute('data-name') || '';
        btn.style.display = (!q || name.indexOf(q) !== -1) ? '' : 'none';
      });
    });
  }

  function badgeClass(status) {
    return status === 'allowed' ? 'wcc-allowed' : status === 'restricted' ? 'wcc-restricted' : 'wcc-forbidden';
  }

  function ctaHtml(c) {
    if (c.code === 'DE') {
      return '<div class="wcc-cta-box">'
        + '<div class="wcc-cta-content">'
        + '<div class="wcc-cta-text">'
        + '<strong>Grauzone optimal nutzen: Hartschalenzelt wählen</strong>'
        + '<p>Hartschalenzelte öffnen nach oben und bleiben im Fahrzeugumriss – das stärkste Argument für § 12 StVO.</p>'
        + '</div>'
        + '<a href="/collections/hartschalenzelte" class="wcc-cta-btn">Hartschalenzelte ansehen &rarr;</a>'
        + '</div></div>';
    }
    if (c.status === 'allowed') {
      return '<div class="wcc-cta-box">'
        + '<div class="wcc-cta-content">'
        + '<div class="wcc-cta-text">'
        + '<strong>Bereit für ' + c.name + '?</strong>'
        + '<p>Entdecke unsere Dachzelt-Kollektion für dein nächstes Abenteuer in der Wildnis.</p>'
        + '</div>'
        + '<a href="/collections/dachzelte" class="wcc-cta-btn">Alle Dachzelte ansehen &rarr;</a>'
        + '</div></div>';
    }
    return '<div class="wcc-cta-box">'
      + '<div class="wcc-cta-content">'
      + '<div class="wcc-cta-text">'
      + '<strong>Das richtige Dachzelt für jede Reise</strong>'
      + '<p>Von Skandinavien bis Südeuropa – finde dein passendes Zelt bei Altoura.</p>'
      + '</div>'
      + '<a href="/collections/dachzelte" class="wcc-cta-btn">Dachzelte entdecken &rarr;</a>'
      + '</div></div>';
  }

  function showResult(c) {
    var el = document.getElementById('wcc-result');
    if (!el) return;

    var warningHtml = c.warning
      ? '<div class="wcc-warn-box">' + c.warningText + '</div>'
      : '';

    var rulesHtml = c.rules.map(function (r) { return '<li>' + r + '</li>'; }).join('');
    var tipsHtml = c.tips.map(function (t) { return '<li>' + t + '</li>'; }).join('');
    var appsHtml = c.apps.map(function (a) { return '<span class="wcc-app-tag">' + a + '</span>'; }).join('');

    var shareUrl = (function () {
      var u = new URL(window.location.href);
      u.searchParams.set('land', c.code);
      return u.toString();
    })();

    el.innerHTML = '<div class="wcc-result-inner">'
      + '<div class="wcc-result-header">'
      + '<span class="wcc-result-flag">' + c.flag + '</span>'
      + '<div style="flex:1">'
      + '<p class="wcc-result-country">' + c.name.trim() + '</p>'
      + '<span class="wcc-badge ' + badgeClass(c.status) + '">' + c.statusLabel + '</span>'
      + '</div>'
      + '<button class="wcc-share-btn" id="wcc-share-btn" data-url="' + shareUrl + '" title="Link kopieren">🔗 Teilen</button>'
      + '</div>'
      + warningHtml
      + '<p class="wcc-result-summary">' + c.summary + '</p>'
      + '<div class="wcc-result-grid">'
      + '<div><h3 class="wcc-col-h3">Regeln &amp; Gesetze</h3><ul class="wcc-rules-list">' + rulesHtml + '</ul></div>'
      + '<div><h3 class="wcc-col-h3">Praxis-Tipps</h3><ul class="wcc-tips-list">' + tipsHtml + '</ul></div>'
      + '</div>'
      + '<div class="wcc-fines-row"><span class="wcc-fines-label">Mögliche Strafen:</span><span class="wcc-fines-val">' + c.fines + '</span></div>'
      + '<div class="wcc-apps-row"><span class="wcc-apps-label">Empfohlene Apps:</span><div class="wcc-apps-tags">' + appsHtml + '</div></div>'
      + '<p class="wcc-result-disclaimer">Alle Angaben basieren auf eigener Recherche (Stand 2025) und sind keine Rechtsberatung. Gesetze können sich ändern – bitte bei offiziellen Stellen prüfen.</p>'
      + '</div>'
      + ctaHtml(c);

    var shareBtn = document.getElementById('wcc-share-btn');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = shareBtn.getAttribute('data-url');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            shareBtn.textContent = '✓ Kopiert!';
            setTimeout(function () { shareBtn.textContent = '🔗 Teilen'; }, 2200);
          });
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          shareBtn.textContent = '✓ Kopiert!';
          setTimeout(function () { shareBtn.textContent = '🔗 Teilen'; }, 2200);
        }
      });
    }

    el.classList.add('wcc-visible');
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initFaq() {
    document.querySelectorAll('.wcc-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wcc-faq-item');
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.wcc-faq-item.open').forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  function checkUrlParam() {
    var params = new URLSearchParams(window.location.search);
    var land = params.get('land');
    if (!land) return;
    var country = COUNTRIES.find(function (c) { return c.code === land.toUpperCase(); });
    if (!country) return;
    var btn = document.querySelector('[data-code="' + country.code + '"]');
    if (btn) btn.classList.add('selected');
    showResult(country);
  }

  document.addEventListener('DOMContentLoaded', function () {
    buildGrid();
    initSearch();
    initFaq();
    checkUrlParam();
  });
})();
